import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

import { useConnectionPlatform } from '../hooks/useConnectionPlatform.js';

/**
 * The title + description pair every add form opens with — identical
 * markup and copy across Amazon/Zemanta/the 9 generic omni platforms
 * (mirrors legacy's `AddConnectionOAuthForm`/`AddConnectionBasicForm`).
 * Reads the platform label itself so callers don't need their own
 * `useConnectionPlatform()` call just for this.
 */
export function ConnectAccountIntro() {
  const { t } = useTranslation('@mint-lib/connections-ui');
  const platform = useConnectionPlatform();

  return (
    <>
      <h4 className={typographyVariants({ variant: 'h4' })}>
        {t('Connect {{platformName}} account', {
          platformName: platform?.label,
        })}
      </h4>
      <p className={typographyVariants({ variant: 'bodyLong01' })}>
        {t(
          'Give this connection a name to help you recognize it later easily, especially if you connect more than one account.',
        )}
      </p>
    </>
  );
}
